import {useLocation, useNavigate} from 'react-router-dom';
import {sendLog} from "../functions/common/SendLog";
import React, {useEffect, useState} from 'react';
import {ServerApi} from "../api/ServerApi";

//Стили
import './style/documents.css';
import "./style/palette.css";
import "./style/common.css";

//Страница предварительного просмотра.
export default function OneDoc() {
    const [retryTrigger, setRetryTrigger] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [docOne, setDocOne] = useState(null);
    const [error, setError] = useState(null);
    const {pathname, state} = useLocation();
    const navigate = useNavigate();

    const docSessionCode = localStorage.getItem("doc_session_code");
    const appDebag = localStorage.getItem("app_debag");
    const title = 'Страница предварительного просмотра.';
    const serverApi = new ServerApi();
    const id = pathname.slice(5);
    const passedName = state?.name;
    const documentName = passedName || docOne?.name || docOne?.title || 'Документ';

    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await serverApi.getPreviewOne(docSessionCode, id, appDebag);

                if (!isMounted) return;

                if (response?.data?.success) {
                    if (response?.data?.reload !== undefined) {
                        setRetryTrigger(Number(response?.data?.reload) + 1);
                        return;
                    }

                    const data = response?.data?.data;
                    setDocOne(data);
                    setError(null);
                    sendLog(serverApi, title, 'Запрос на предпросмотр документа', 'getPreviewOne', false, response);
                } else {
                    setError(response?.data?.error || ['Не удалось загрузить документ']);
                    sendLog(serverApi, title, 'Запрос на предпросмотр документа', 'getPreviewOne', true, response);
                }
            } catch (err) {
                if (!isMounted) return;
                setError(['Ошибка загрузки', 'Попробуйте снова']);
                sendLog(serverApi, title, 'Запрос на предпросмотр документа', 'getPreviewOne', true, {docSessionCode, error: err});
            } finally {
                if (isMounted) setIsLoading(false);
            }
        };

        fetchData();

        return () => { isMounted = false; };
    }, [id, docSessionCode, retryTrigger]);

    if (isLoading) {
        return (
            <div className={"d-flex justify-content-center align-items-center min-vh-100"}>
                <div className={"loader-text"}>Загрузка документа...</div>
            </div>
        );
    }

    if (error) {
        return (
            <>
                <div className={'header d-flex align-items-center justify-content-between background_white'}>
                    <h1 className={'header-title color_night_blue weight600_project size20_project'}>
                        Ошибка
                    </h1>
                </div>
                <div className={"doc-block margin100_top text-center"}>
                    {Array.isArray(error) ?
                        error.map((e, i) => <p key={i} className={"errWarningTextDoc color_night_blue"}>{e}</p>) :
                        <p className={"errWarningTextDoc color_night_blue"}>{error}</p>
                    }
                </div>

                <div className="fixed-bottom mx-auto d-flex justify-content-center width90">
                    <button className={`doc-btn margin40_bottom w-100 border-0 weight600_project size14_project cursor color_white background_bondi`}
                            onClick={() => navigate('/doc')}>
                        Вернуться
                    </button>
                </div>
            </>
        );
    }

    return (
        <>
            <div className={'header d-flex align-items-center justify-content-between background_white'}>
                <h1 className={'header-title color_night_blue weight600_project size20_project'}>
                    {documentName}
                </h1>
            </div>
            <div id={"docs-container"}>
                {docOne?.map((page, index) => (
                    <div key={index} className={'doc-pdf mx-3 d-flex justify-content-center align-items-center background_white'}>
                        <img src={page} alt={`Страница ${index + 1}`} className={'w-100'}/>
                    </div>
                ))}
            </div>
            <div className="fixed-bottom mx-auto d-flex justify-content-center width90">
                <button className={`doc-btn margin40_bottom w-100 border-0 weight600_project size14_project cursor color_white background_bondi`}
                        onClick={() => navigate('/doc')}>
                    Вернуться
                </button>
            </div>
        </>
    );
};
